/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Canvas_Open_Artifact_PromptInputs */



/**
* | output |
* | --- |
* | "This app wants to open another item in this window." |
*
* @param {Canvas_Open_Artifact_PromptInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_open_artifact_prompt = /** @type {((inputs?: Canvas_Open_Artifact_PromptInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Open_Artifact_PromptInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese App möchte ein anderes Element in diesem Fenster öffnen.")
	return /** @type {LocalizedString} */ ("This app wants to open another item in this window.")
});